<div class="site-container">
  <div class="image-container">
    <img
      src="assets/fondos/site-in-maintenance-client.svg"
      alt="Sitio en mantenimiento"
    />
  </div>

  <div class="info">
    <h1>Sitio en mantenimiento</h1>
    <p>
      Estamos haciendo algunos ajustes para brindarte un mejor servicio. Gracias
      por tu comprensión, pronto estaremos de regreso.
    </p>
    <button [routerLink]="['/home']">Volver a la página principal</button>
  </div>
</div>
